import { useMemo } from 'react';
import { FiCountry, useLocale } from '../contexts/LocaleContext';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../lib/growthbook';
import useCartHasFreeTrialBundle from './useCartHasFreeTrialBundle';

/**
 * Determines if the new CartItemV2 component should be shown.
 * Currently enabled for Canada + free trial only, with plans to expand.
 * Can be disabled via GrowthBook flag 'enable-cart-item-v2' (defaults to true).
 */
export default function useCartItemV2Enabled(): boolean {
  const { country } = useLocale();
  const hasFreeTrialBundle = useCartHasFreeTrialBundle();
  const isGrowthBookEnabled = useIsGrowthBookEnabled();

  return useMemo(() => {
    const isFeatureEnabled = isGrowthBookEnabled
      ? getFiGrowthBook().getFeatureValue<boolean>('enable-cart-item-v2', true)
      : true;

    const isCanada = country === FiCountry.CA;
    return isFeatureEnabled && isCanada && hasFreeTrialBundle;
  }, [country, hasFreeTrialBundle, isGrowthBookEnabled]);
}
